import { combineReducers } from 'redux';

import auth from './reducers/authReducer';
import dashboard from './reducers/dashboardReducer';
import store from './reducers/sroreReducers';
import product from './reducers/productReducer';
// import order from './reducers/orderReducer';


const rootReducer = combineReducers({
   
  auth,
  dashboard,
  store,
  product,
  // order,
  
  })
  
  export default rootReducer